import React, { Component } from "react";
import PropTypes from "prop-types";
import ActivityButton from "../ActivityButton/ActivityButton";
import dropdownIcon from "../../../assets/images/dropdown-arrow.svg";
import "./MonthPicker.css";
import moment from "moment";
import onClickOutside from "react-onclickoutside";
import Button from "../Button/Button";
import { futureYearCount, defaultYear } from "../../../shared/constants";
import ConsoleLog from "../../../hoc/ConsoleLog/ConsoleLog";

const months = [
  "January",
  "Febuary",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December"
];

const years = () => {
  let startYear = defaultYear;
  let endYear = new Date().getFullYear() + futureYearCount,
    years = [];
  while (startYear <= endYear) {
    years.push(startYear++);
  }
  return years;
};

/**
 * @desc MonthPicker
 * @param props
 * @return null
 */
class MonthPicker extends Component {
  constructor(props) {
    super(props);
    const { value } = this.props;
    const dateArray =
      value !== "0000-00-00 00:00:00" && value !== ""
        ? value.split(" ")[0].split("-")
        : [];
    const selectedYear = dateArray.length > 0 ? dateArray[0] : "";
    const selectedMonth =
      dateArray.length > 0 ? parseInt(dateArray[1]) - 1 : "";
    this.state = {
      open: false,
      month: selectedMonth,
      year: selectedYear,
      error: null,
      doneBtndisabled: false
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      const { value } = this.props;
      const dateArray =
        value !== "0000-00-00 00:00:00" && value !== ""
          ? value.split(" ")[0].split("-")
          : [];
      const selectedYear = dateArray.length > 0 ? dateArray[0] : "";
      const selectedMonth =
        dateArray.length > 0 ? parseInt(dateArray[1]) - 1 : "";
      this.setState({ month: selectedMonth, year: selectedYear, error: null });
    }

  }

  handleCalendar = () => {
    this.setState({
      open: !this.state.open,
      error: null
    });
  };

  handleClickOutside = () => {
    this.setState({
      open: false
    });
  };

  handleChange = (e,fieldName, fieldIndex, itemType) => {
    const name = e.target.id;
    const value = e.target.value;
    this.setState({ [name]: value });
    if(this.state.year !== '' && this.state.month !== ''){

      if(this.props.label){
        if(this.props.label === 'From'){

           if(itemType === 'year'){
            if(parseInt(value) > moment(this.props.dateEnd).format('YYYY')){
              this.setState({doneBtndisabled: true, error:'From date must be before To date'});
            }else if(parseInt(value) == moment(this.props.dateEnd).format('YYYY')){
              if((parseInt(this.state.month)+1) >= moment(this.props.dateEnd).format('M')){
                  this.setState({doneBtndisabled: true, error:'From date must be before To date'});  
              }else{
                this.setState({doneBtndisabled: false, error: ''})
              }
            }else{
                if(this.props.dateEnd === '' || this.props.dateEnd === '0000-00-00 00:00:00' || this.props.dateEnd === null){
                  let newDate = new Date();
                  if((parseInt(value)) == moment(newDate).format('YYYY')){
                    if((parseInt(this.state.month)+1) >= moment(newDate).format('M')){
                      this.setState({doneBtndisabled: true, error:'From date must be before To date'});  
                    }else{
                      this.setState({doneBtndisabled: false, error: ''})
                    }
                  }else{
                    this.setState({doneBtndisabled: false, error: ''})
                  }
                }else{
                  this.setState({doneBtndisabled: false, error: ''})
                }
            }

          }else{ 

            if((parseInt(value)+1) > moment(this.props.dateEnd).format('M')){
              if(this.state.year >= moment(this.props.dateEnd).format('YYYY')){
                this.setState({doneBtndisabled: true, error: 'From date must be before To date'});
              }else{
                this.setState({doneBtndisabled: false, error: ''});
              }
            }else{
              this.setState({doneBtndisabled: false, error: ''})
            }
            
          }

        }else{

          if(itemType === 'year'){
            if(value === moment(this.props.dateStart).format('YYYY')){
              if(this.state.month < moment(this.props.dateStart).format('M')){
                this.setState({month: parseInt(moment(this.props.dateStart).format('M'))});
              }
            }
          }

        }
      }

    }else{
      this.setState({ error: "Please select Month & Year" });
    }
  };

  handleDateSelect = (e, fieldName, fieldIndex) => {
    e.preventDefault();
    if (this.state.year !== "" && this.state.month !== "") {
      this.props.handleDateChange(
        e,
        fieldName,
        fieldIndex,
        this.state.year,
        this.state.month
      );
    } else {
      this.setState({ error: "Please select Month & Year" });
    }
  };

  render() {
    const { className, value, ...other } = this.props;
    const dateArray =
      value !== "0000-00-00 00:00:00" && value !== ""
        ? value.split(" ")[0].split("-")
        : [];

    let dateVal = "";
    if(dateArray.length > 0 ) {
      if(this.props.value !== '0000-00-00'){
        dateVal = moment(new Date(this.props.value)).format("MMMM YYYY").toString();
      }
    }

    return (
      <div className={"ui-datepicker " + className}>
        <label>{this.props.label}</label>
        <span className="form-error-message">
          {this.props.error || this.state.error}
        </span>
        <div className={"ui-datepicker__wrapper ui-datepicker--position-right"}>
          <div className="ui-datepicker__icon">
            <img onClick={this.handleCalendar} src={dropdownIcon} />
          </div>
          <div className="ui-datepicker__content">
            <input onClick={this.handleCalendar} value={dateVal} />
            <div
              className={
                this.state.open ? "month-selector" : "month-selector hide"
              }
              handleClickOutside={this.handleClickOutside}
            >
              <div>
                <label>Month</label>
                <select
                  value={this.state.month}
                  id="month"
                  className="month-selector"
                  onChange={(e) => this.handleChange(e, this.props.fieldName, this.props.fieldIndex, 'month')}
                >
                  <option value="">Select</option>
                  {months.map((month, index) => {

                    let disabled=false;

                    if(this.props.dateStart){
                      if(moment(this.props.dateStart).format('YYYY') === this.state.year){
                        if(index+1 <= moment(this.props.dateStart).format('M')){
                          disabled= true;
                        }
                      }
                    }

                    if(this.props.presentJob){
                      if(moment().format('YYYY') === this.state.year){
                        if(index+1 > moment().format('M')){
                          disabled = true;
                        }
                      }
                    }

                    return(
                      <option value={index} disabled={disabled}>{month}</option>
                    )
                  })}
                </select>
              </div>
              <div>
                <label>Year</label>
                <select
                  value={this.state.year}
                  id="year"
                  className="year-selector"
                  onChange={(e) => this.handleChange(e, this.props.fieldName, this.props.fieldIndex,'year')}
                >
                  <option value="">Select</option>
                  {years().map(year => {
                      let disabled=false;
                      if(this.props.dateStart){
                        if( year < moment(this.props.dateStart).format('YYYY')){
                          disabled = true;
                        }
                      }

                      if(this.props.presentJob || this.props.label === 'From'){
                        if(year > moment().format('YYYY')){
                          return;
                        }
                      }

                      return (<option value={year} disabled={disabled}>{year}</option>);
                   }
                  )}
                </select>
              </div>
              <Button
                uistyle="secondary"
                disabled={this.state.doneBtndisabled}
                onClick={e => {
                  this.handleDateSelect(
                    e,
                    this.props.fieldName,
                    this.props.fieldIndex,
                  );
                  this.handleClickOutside();
                }}
              >
                Done
              </Button>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

MonthPicker.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string
};

MonthPicker.defaultProps = {
  className: "",
  label: "",
  value: ""
};

export default onClickOutside(MonthPicker);



// WEBPACK FOOTER //
// ./src/components/UI/MonthPicker/MonthPicker.js